import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Label } from "@cars24/turbo-web/lib/label";
import {ActionBar} from "@cars24/turbo-web/lib/action-bar";
import { Button } from "@cars24/turbo-web/lib/button";
import {whyAdvertise} from "./constants";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import {Divider} from "@cars24/turbo-web/lib/divider";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import ArrowIcon from "./images/back-icon.svg";
import PostInspectionDiyModal from "../../shared/post-inspection-diy-modal";

const PostInspectionMarketplaceWhyAdModal = ({ onClick, isOpen, onClose, ctaText }) => {
    const {tokens} = useTokens();
    return (
        isOpen ? <PostInspectionDiyModal
            onClose={onClose}
            showCloseButton={false}
            height="100%"
            width="420px"
            id="why-ad-portal"
            defaultPadding={false}
        >
            <div styleName="styles.container">
                <div styleName="styles.logoContainer">
                    <img src={ArrowIcon} alt="logo" onClick={onClose}/>
                    <img src={whyAdvertise.header.logo} alt="logo" styleName="styles.logo" />
                </div>
                {whyAdvertise.pageTitle && (
                    <div styleName="styles.pageTitle">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.pageTitle.heading}</Label>
                        <table styleName="styles.pageTitleBenifits">
                            <tr>
                                {whyAdvertise.pageTitle.tableColumns.map((item, index) => {
                                    return (
                                        <th key={index}>
                                            <Label level={NUMBER.TWO} fontWeight="semibold" color={item.color}>{item.label}</Label>
                                        </th>
                                    );
                                })}
                            </tr>
                            <Divider/>
                            {whyAdvertise.pageTitle.tableData.map((row, index) => {
                                return (<tr key={`${index}`}> {whyAdvertise.pageTitle.tableColumns.map((column, idx) => {
                                    return (

                                        <td key={idx}>
                                            {row[column.key].icon && <img src={row[column.key].icon} alt={`${column.key}_${index}`} />}
                                            <BodyText level={NUMBER.THREE} color={tokens.text_default_text_primary}>{row[column.key].label}</BodyText>
                                        </td>
                                    );
                                })}
                                </tr>);
                            })}
                        </table>
                    </div>
                )}
                {whyAdvertise.cars24Offer && (
                    <div styleName="styles.cars24Offer">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.cars24Offer.heading}</Label>
                        <div styleName="styles.cars24OfferList">
                            {whyAdvertise.cars24Offer.offers.map((item, index) => (
                                <div key={index} styleName="styles.cars24OfferItems">
                                    {item.icon && <img src={item.icon} alt={`offer_${index}`} />}
                                    <Label level={NUMBER.FOUR} fontWeight="regular">{item.label}</Label>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {whyAdvertise.whyToSell && (
                    <div styleName="styles.whyToSell">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.whyToSell.heading}</Label>
                        <div styleName="styles.whyToSellList">
                            {whyAdvertise.whyToSell.benifits.map((item, index) => (
                                <div key={index} styleName="styles.whyToSellItems">
                                    <img src={item} alt={`benifits_${index}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {whyAdvertise.smartSolution && (
                    <div styleName="styles.smartSolution">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.smartSolution.heading}</Label>
                        <div styleName="styles.smartSolutionList">
                            {whyAdvertise.smartSolution.solutions.map((item, index) => (
                                <div key={index} styleName="styles.smartSolutionItems">
                                    <Label level={NUMBER.TWO} fontWeight="semibold" color={tokens.text_default_text_primary}>{index + 1}. {item.label}</Label>
                                    <img src={item.icon} alt={`solution_${index}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {whyAdvertise.stepsToSell && (
                    <div styleName="styles.stepsToSell">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.stepsToSell.heading}</Label>
                        <div styleName="styles.stepsToSellList">
                            {whyAdvertise.stepsToSell.steps.map((item, index) => (
                                <div key={index} styleName="styles.stepsToSellItems">
                                    <div styleName="styles.stepNumber">
                                        <Label level={NUMBER.TWO} color={tokens.text_brand_text_accent}>{(index + 1).toString().padStart(NUMBER.TWO, "0")}</Label>
                                    </div>
                                    <Label level={NUMBER.THREE} color={tokens.text_default_text_primary}>{item}</Label>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {whyAdvertise.tipsToSell && (
                    <div styleName="styles.tipsToSell">
                        <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{whyAdvertise.tipsToSell.heading}</Label>
                        <div styleName="styles.tipsToSellList">
                            {whyAdvertise.tipsToSell.tips.map((item, index) => (
                                <div key={index} styleName="styles.tipsToSellItems">
                                    <img src={item.icon} alt={`tips_${index}`} />
                                    <Label level={NUMBER.THREE} color={tokens.text_default_text_primary}>{item.description}</Label>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div styleName="styles.actionBar">
                    <ActionBar.Container>
                        <ActionBar.Content>
                            <Button size="large" onClick={onClick} label={ctaText}/>
                        </ActionBar.Content>
                    </ActionBar.Container>
                </div>
            </div>
        </PostInspectionDiyModal> : null
    );
};

PostInspectionMarketplaceWhyAdModal.propTypes = {
    onClick: PropTypes.func,
    ctaText: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func
};

export default PostInspectionMarketplaceWhyAdModal;
